import {
  createTheme,
  defaultVariantColorsResolver,
  type VariantColorsResolverInput,
} from "@mantine/core";

export const theme = createTheme({
  variantColorResolver: (input: VariantColorsResolverInput) => {
    return defaultVariantColorsResolver(input);
  },
  colors: {
    // blue: ["#FFD6AF", "#FFD6AF", "#FFD6AF", "#C49E85", "#C49E85", "#C49E85", "#C49E85", "#6B4B3E", "#6B4B3E", "#6B4B3E", ],
    blue: [
      "#e6f7ff",
      "#e6f7ff",
      "#d7e9f8",
      "#d7e9f8",
      "#b3d1e7",
      "#b3d1e7",
      "#8cb6d7",
      "#8cb6d7",
      "#6ba0ca",
      "#6ba0ca",
    ],
    second: [
      "#fff3e2",
      "#fde6d0",
      "#f6cba4",
      "#efaf74",
      "#e9974c",
      "#e58832",
      "#e48023",
      "#cb6d15",
      "#b5600e",
      "#9e5202",
    ],
    third: [
      "#e2fdfa",
      "#d5f5f1",
      "#b1e7e0",
      "#89d8cf",
      "#68ccc0",
      "#52c5b7", // orig
      "#44c1b3",
      "#31aa9d",
      "#21988b",
      "#008478",
    ],
    light: [
      "#FEFEFE",
      "#FEFDFE",
      "#FDFCFD",
      "#FCFBFD",
      "#FCFAFC",
      "#FBF9FC",
      "#FBF8FB",
      "#FAF7FB",
      "#F9F6FA",
      "#F9F5FA",
    ],
    "light-accent": [
      "#F9F6FC",
      "#F2EEFA",
      "#ECE5F7",
      "#E5DCF5",
      "#DFD4F2",
      "#D8CBF0",
      "#D2C3ED",
      "#CCBAEA",
      "#C5B1E8",
      "#BFA9E5",
    ],
    "dark-accent": [
      "#ffe8e8",
      "#ffd0d0",
      "#fda09f",
      "#fa6c6a",
      "#f7413e",
      "#f62521",
      "#f61412",
      "#db0407",
      "#c40004",
      "#ab0000",
    ],
  },
  // primaryColor: "blue",
  primaryShade: 9,
});
